/** Türkçe sözlük · ui: ortak arayüz parçaları (`src/ui/*`). */
export const ui = {
  /** Tutar alanının altında, okunan değer. */
  anlasilan: (deger: string) => `Anlaşılan: ${deger}`,
  alanZorunlu: "Bu alan zorunlu.",
  /** Dönen simgenin yanındaki kısa etiket (üç noktasız). */
  yukleniyor: "Yükleniyor",
  veriOkunamadi: "Veri okunamadı",
  /** Para birimi seçicide listede olmayan eski kod. */
  paraBirimiTaninmiyor: (kod: string) => `${kod} — tanınmıyor`,
};
